<template>
  <div class="content">
    <div class="title">资金明细</div>
    <Search class="search" :searchForm="searchForm" :searchList="searchList" :optionsType="option"></Search>
    <!--    表格-->
    <el-table
      class="table"
      v-loading="searchForm.Loading"
      :data="tableList.list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      header-row-class-name="header"
    >
      <el-table-column type="index" label="序号"  width="55" :index="indexMethod" align="center"/>
      <el-table-column
        v-for="(item,index) in tableData"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
          <span>{{row[item.value]}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total">
    </el-pagination>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
export default {
  components:{
    Search
  },
  name: "index",
  data(){
    return{
      searchForm: {
        relation: '',
        category: '',
        remark: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        appKey:localStorage.getItem('appKeyMini'),
        Loading: true
      },
      searchList: [
        {
          id: 'relation',
          text: '订单号',
          placeholder: '请输入订单号',
          type: 'input'
        }, {
          id: 'remark',
          text: '资金明细',
          placeholder: '请输入资金明细',
          type: 'input'
        }, {
          id: 'category',
          text: '类型',
          placeholder: '请选择',
          type: 'select'
        }],
      // 表头
      tableData: [{
          text: '单号',
          value: 'relation',
        }, {
          text: '类型',
          value: 'categoryStr',
        }, {
          text: '资金明细',
          value: 'remark',
        }, {
          text: '变动金额',
          value: 'amount',
        },{
          text: '变动时间',
          value: 'createTime',
        },{
          text: '变动后账户金额',
          value: 'afterAmount',
        }
      ],
      tableList:[],
      currentPage:1,
      dialogVisible:true,
      option:[{
        label:'收入',
        value:1
      },{
        label:'支出',
        value:2
      }]
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose(){
      this.dialogVisible = false
    },
    getList(){
      MiniModel.financialDetails(this.searchForm).then(res=>{
        if (res.data.code == 200) {
          this.tableList = res.data.data
          this.searchForm.Loading = false
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    // 导出
    exportButton() {
      MiniModel.exportMovieDetail(this.searchForm).then(res => {
        console.log(res)
        if (res.status == 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          console.log('blob', blob)
          let url = window.URL.createObjectURL(blob)
          console.log('url', url)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = window.URL.createObjectURL(blob)
          a.download = '资金明细列表导出_' + this.formatDate(new Date()) + '.xls'
          a.click()
          window.URL.revokeObjectURL(url)
        } else {
          // this.$Message.error(res.info || res.message)
        }
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + m + d;
    },
  }
}
</script>

<style scoped lang="less">
.content{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
}
.table{
  margin-top: 10px;
}
.dialog{
  padding: 20px 80px;
  .dialog-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }
  .dialog-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
  }
  .dialog-button{
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;
    .button-success{
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}
/deep/.el-table th, .el-table tr{
  background-color: #FCFAF8;
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #EEEEEE;
}
.pagination{
  margin-top: 20px;
  text-align: right;
}
.search{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/financialDetails/index.vue